import React from "react";

export const Example = (): React.ReactElement => {
  return <h1>Example page</h1>;
};

export default Example;
